import _toConsumableArray from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Kind, parse, visit } from 'graphql';
import { offsetToPosition } from 'graphql-language-service-utils';
var INLINE_FRAGMENT = Kind.INLINE_FRAGMENT;
var OUTLINEABLE_KINDS = {
  Field: true,
  OperationDefinition: true,
  Document: true,
  SelectionSet: true,
  Name: true,
  FragmentDefinition: true,
  FragmentSpread: true,
  InlineFragment: true,
  ObjectTypeDefinition: true,
  InputObjectTypeDefinition: true,
  InterfaceTypeDefinition: true,
  EnumTypeDefinition: true,
  EnumValueDefinition: true,
  InputValueDefinition: true,
  FieldDefinition: true
};
export function getOutline(documentText) {
  var ast;

  try {
    ast = parse(documentText);
  } catch (error) {
    return null;
  }

  var visitorFns = outlineTreeConverter(documentText);
  var outlineTrees = visit(ast, {
    leave: function leave(node) {
      if (visitorFns !== undefined && node.kind in visitorFns) {
        return visitorFns[node.kind](node);
      }

      return null;
    }
  });
  return {
    outlineTrees: outlineTrees
  };
}

function outlineTreeConverter(docText) {
  var meta = function meta(node) {
    return {
      representativeName: node.name,
      startPosition: offsetToPosition(docText, node.loc.start),
      endPosition: offsetToPosition(docText, node.loc.end),
      kind: node.kind,
      children: node.selectionSet || node.fields || node.values || node.arguments || []
    };
  };

  return {
    Field: function Field(node) {
      var tokenizedText = node.alias ? [buildToken('plain', node.alias), buildToken('plain', ': ')] : [];
      tokenizedText.push(buildToken('plain', node.name));
      return Object.assign({
        tokenizedText: tokenizedText
      }, meta(node));
    },
    OperationDefinition: function OperationDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('keyword', node.operation), buildToken('whitespace', ' '), buildToken('class-name', node.name)]
      }, meta(node));
    },
    Document: function Document(node) {
      return node.definitions;
    },
    SelectionSet: function SelectionSet(node) {
      return concatMap(node.selections, function (child) {
        return child.kind === INLINE_FRAGMENT ? child.selectionSet : child;
      });
    },
    Name: function Name(node) {
      return node.value;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('keyword', 'fragment'), buildToken('whitespace', ' '), buildToken('class-name', node.name)]
      }, meta(node));
    },
    InterfaceTypeDefinition: function InterfaceTypeDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('keyword', 'interface'), buildToken('whitespace', ' '), buildToken('class-name', node.name)]
      }, meta(node));
    },
    EnumTypeDefinition: function EnumTypeDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('keyword', 'enum'), buildToken('whitespace', ' '), buildToken('class-name', node.name)]
      }, meta(node));
    },
    EnumValueDefinition: function EnumValueDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('plain', node.name)]
      }, meta(node));
    },
    ObjectTypeDefinition: function ObjectTypeDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('keyword', 'type'), buildToken('whitespace', ' '), buildToken('class-name', node.name)]
      }, meta(node));
    },
    InputObjectTypeDefinition: function InputObjectTypeDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('keyword', 'input'), buildToken('whitespace', ' '), buildToken('class-name', node.name)]
      }, meta(node));
    },
    FragmentSpread: function FragmentSpread(node) {
      return Object.assign({
        tokenizedText: [buildToken('plain', '...'), buildToken('class-name', node.name)]
      }, meta(node));
    },
    InputValueDefinition: function InputValueDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('plain', node.name)]
      }, meta(node));
    },
    FieldDefinition: function FieldDefinition(node) {
      return Object.assign({
        tokenizedText: [buildToken('plain', node.name)]
      }, meta(node));
    },
    InlineFragment: function InlineFragment(node) {
      return node.selectionSet;
    }
  };
}

function buildToken(kind, value) {
  return {
    kind: kind,
    value: value
  };
}

function concatMap(arr, fn) {
  var res = [];

  for (var i = 0; i < arr.length; i++) {
    var x = fn(arr[i], i);

    if (Array.isArray(x)) {
      res.push.apply(res, _toConsumableArray(x));
    } else {
      res.push(x);
    }
  }

  return res;
}